export class EventReservationAction {

  /**
   * Edit an existing reservation
   *
   * @type {string}
   */
  static readonly EDIT_RESERVATION = 'EDIT_RESERVATION';
  /**
   * Create a reservation for a RSVP
   *
   * @type {string}
   */
  static readonly RSVP_CONFIRMATION = 'RSVP_CONFIRMATION';
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-reservation-action.ts